import { createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to save draft to localStorage for persistence
export const saveDraftToStorage = createAsyncThunk(
  'projectDraft/saveToStorage',
  async (_, { getState }) => {
    try {
      const state = getState().projectDraft;
      localStorage.setItem('projectDraft', JSON.stringify(state));
      return true;
    } catch (error) {
      console.error('Failed to save project draft:', error);
      return false;
    }
  }
);

// Async thunk to load draft from localStorage
export const loadDraftFromStorage = createAsyncThunk(
  'projectDraft/loadFromStorage',
  async () => {
    try {
      const saved = localStorage.getItem('projectDraft');
      if (saved) {
        return JSON.parse(saved);
      }
      return null;
    } catch (error) {
      console.error('Failed to load project draft:', error);
      return null;
    }
  }
);
